import Translator from 'bazinga-translator'

import { initCurrentLocale } from './dates'

export async function initTranslations() {
  const promises: Promise<void | string>[] = [initCurrentLocale()]
  const lang = window.lang || window.APP.locale
  switch (lang) {
    case 'en':
      promises.push(
        new Promise((resolve: (translations: string) => void) => {
          import(/* webpackChunkName: "translations_en" */ '../i18n/en.json').then((translations) => {
            resolve(JSON.stringify(translations.default))
          })
        }),
      )
      break
    case 'sk':
      promises.push(
        new Promise((resolve: (translations: string) => void) => {
          import(/* webpackChunkName: "translations_sk" */ '../i18n/sk.json').then((translations) => {
            resolve(JSON.stringify(translations.default))
          })
        }),
      )
      break
    case 'es':
      promises.push(
        new Promise((resolve: (translations: string) => void) => {
          import(/* webpackChunkName: "translations_es" */ '../i18n/es.json').then((translations) => {
            resolve(JSON.stringify(translations.default))
          })
        }),
      )
      break

    default:
      promises.push(
        new Promise((resolve: (translations: string) => void) => {
          import(/* webpackChunkName: "translations_cs" */ '../i18n/cs.json').then((translations) => {
            resolve(JSON.stringify(translations.default))
          })
        }),
      )
      break
  }

  try {
    const [, translations] = await Promise.all(promises)

    Translator.fromJSON(translations as string)
  } catch (error) {
    setTimeout(() => {
      initTranslations()
    }, 500)
  }
}
